import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useFormContext } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import {
  FieldsetCard,
  FieldsetCardProps,
  getDisabledClasses,
} from "~/common/components/ui/FieldsetCard";
import Input from "~/common/components/ui/Input";
import Select from "~/common/components/ui/select/Select";
import { formatPhoneNumberField } from "~/common/utils/formatPhoneNumberField";
import {
  RELATIONSHIPS,
  relationshipsOptions,
} from "~/patients/constants/relationships";
import { UpdatePatientDetailsForm } from "~/providers/types/patients";

export const EmergencyContactFieldset = ({
  disabled,
  ...props
}: Omit<FieldsetCardProps, "title" | "className">) => {
  const {
    register,
    formState: { errors },
    control,
    watch,
  } = useFormContext<UpdatePatientDetailsForm>();

  const isOtherRelationship =
    watch("emergencyContactRelationship") === RELATIONSHIPS.OTHER;

  return (
    <FieldsetCard
      title="Emergency Contact"
      className="border-none p-0 shadow-none"
      contentClassName={twMerge("sm:grid-cols-2", disabled && "sm:grid-cols-4")}
      disabled={disabled}
      {...props}
    >
      <Input
        label="First name"
        {...getDisabledClasses(disabled)}
        {...register("emergencyContactFirstName")}
        error={errors.emergencyContactFirstName?.message}
        disabled={disabled}
      />
      <Input
        label="Last name"
        {...getDisabledClasses(disabled)}
        {...register("emergencyContactLastName")}
        error={errors.emergencyContactLastName?.message}
        disabled={disabled}
      />
      <Select
        id="emergencyContactRelationship"
        label="Relationship"
        placeholder={"Select relationship"}
        options={relationshipsOptions}
        control={control}
        error={errors.emergencyContactRelationship?.message}
        isDisabled={disabled}
        buttonClassName="disabled:bg-transparent disabled:border-none disabled:p-0 disabled:h-auto"
        icon={disabled ? <ChevronDownIcon /> : undefined}
      />
      {isOtherRelationship && (
        <Input
          label="Custom relationship"
          {...getDisabledClasses(disabled)}
          {...register("emergencyCustomRelationship")}
          placeholder="Enter relationship"
          error={errors?.emergencyCustomRelationship?.message}
          disabled={disabled}
        />
      )}

      <Input
        label="Mobile number"
        {...getDisabledClasses(disabled)}
        {...register("emergencyContactMobileNumber")}
        {...formatPhoneNumberField<UpdatePatientDetailsForm>(
          "emergencyContactMobileNumber",
          register,
        )}
        error={errors.emergencyContactMobileNumber?.message}
        disabled={disabled}
      />
      <Input
        label="Email"
        {...getDisabledClasses(disabled)}
        {...register("emergencyContactEmail")}
        error={errors.emergencyContactEmail?.message}
        disabled={disabled}
      />
    </FieldsetCard>
  );
};
